export const AUTO_HIDE_TIMER_MS = 3000;

export const COMPARE_PAGE_URL = '/compare/';

export const SNACKBAR_IDLE_KEY = 'snackbar-idle';
export const COMPARE_STATUS_ID = 'compare-status';
